module.exports = __webpack_public_path__ + "static/eye-main-e4547af64386174da9afe1f398e15f69.svg";